const guard = {
    invalid_input: 'Żądanie {{type}} jest nieprawidłowe.',
    invalid_pagination: 'Nieprawidłowa wartość paginacji żądania.',
    can_not_get_tenant_id: 'Nie można pobrać identyfikatora najemcy z żądania.',
    file_size_exceeded: 'Przekroczono rozmiar pliku.',
    mime_type_not_allowed: 'Nie dozwolony typ MIME.',
};
export default Object.freeze(guard);
